/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Api_Keys_Toasts_Delete_Error_TitleInputs */

const es_user_profile_api_keys_toasts_delete_error_title = /** @type {(inputs: User_Profile_Api_Keys_Toasts_Delete_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo eliminar la clave API`)
};

const en_user_profile_api_keys_toasts_delete_error_title = /** @type {(inputs: User_Profile_Api_Keys_Toasts_Delete_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to delete API key`)
};

/**
* | output |
* | --- |
* | "Failed to delete API key" |
*
* @param {User_Profile_Api_Keys_Toasts_Delete_Error_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_api_keys_toasts_delete_error_title = /** @type {((inputs?: User_Profile_Api_Keys_Toasts_Delete_Error_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Api_Keys_Toasts_Delete_Error_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_api_keys_toasts_delete_error_title(inputs)
	return en_user_profile_api_keys_toasts_delete_error_title(inputs)
});
export { user_profile_api_keys_toasts_delete_error_title as "user.profile.api_keys.toasts.delete.error_title" }